<template>
  <div style="padding-bottom: 50px;">
    <router-view />

  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      vueAppType: 'guider'
    }
  },
  created() {
    this.vueAppType = process.env.VUE_APP_TYPE
  }
}
</script>

<style lang="scss">

</style>

